
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const IntroductionSection = () => {
  return (
    <section className="bg-[#0A0A0A] py-24 px-8">
      <div className="max-w-4xl mx-auto">
        <motion.div 
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="flex flex-col items-center text-center"
        >
          <div className="inline-block px-4 py-1 bg-[#D4AF37]/20 border border-[#D4AF37] rounded-full mb-8">
            <span className="text-[#D4AF37] text-sm tracking-wider">御祭神</span>
          </div>

          <div className="mb-10 border-2 border-[#D4AF37] p-3 rounded-lg">
            <img 
              src="https://public.readdy.ai/ai/img_res/3890cee3cc541b3b1c24a925e4ba70ea.jpg" 
              alt="大石内蔵助"
              className="w-full max-w-md h-96 object-cover object-top rounded"
            />
          </div>

          <h2 className="text-white font-serif text-4xl font-bold mb-6 tracking-wide">
            歌舞伎「仮名手本忠臣蔵」で知られる<br />大石内蔵助
          </h2>

          <p className="text-gray-300 leading-loose text-lg mb-10 max-w-2xl">
            大石神社の御祭神は、元禄赤穂事件で知られる大石内蔵助良雄公です。主君浅野内匠頭の無念を晴らすため、四十七士を率いて吉良邸に討ち入りを果たした忠義の武士として、今なお多くの人々に敬愛されています。当神社は、大石内蔵助公の忠義と勇気を後世に伝え、参拝者の皆様に誠実さと正義の心を育んでいただくことを願っております。
          </p>

          <Link 
            to="/chushingura"
            className="inline-flex items-center gap-2 px-8 py-3 bg-[#D4AF37] text-black font-semibold rounded-full hover:bg-[#C4A037] transition-all hover:shadow-[0_0_20px_rgba(212,175,55,0.5)] cursor-pointer whitespace-nowrap"
          >
            忠臣蔵について詳しく
            <i className="ri-arrow-right-line"></i>
          </Link>
        </motion.div>
      </div>
    </section>
  );
};

export default IntroductionSection;
